// Category / lifecycle options - mirror the Twenty app field definitions
// (cls-crm-app/src/fields/company-category.field.ts, company-lifecycle-stage,
// person-category). Values must match the enum option values exactly.

export type Option = { value: string; label: string };

// Same set on Company and Person.
export const CATEGORY_OPTIONS: Option[] = [
  { value: 'INVESTOR', label: 'Investor' },
  { value: 'CUSTOMER', label: 'Customer' },
  { value: 'VENDOR', label: 'Vendor' },
  { value: 'PARTNER', label: 'Partner' },
  { value: 'OTHER', label: 'Other' },
];

export const STAGE_OPTIONS: Option[] = [
  { value: 'PROSPECT', label: 'Prospect' },
  { value: 'ACTIVE', label: 'Active' },
  { value: 'PAST', label: 'Past' },
];

export const DEFAULT_STAGE = 'PROSPECT';
